  (() => {
    const root = document.querySelector('[data-c-gift-root]');
    const cartForm = document.getElementById('CartPageForm');

    if (!root || !cartForm) {
      return;
    }

    const dialog = document.querySelector('[data-c-gift-dialog]');
    const rootMessage = root.querySelector('[data-c-gift-message]');
    const checkoutButtons = Array.from(cartForm.querySelectorAll('[name="checkout"]'));
    const acceleratedCheckout = cartForm.querySelector('.additional-checkout-buttons');
    const checkoutDefaults = new Map(checkoutButtons.map((button) => [button, button.disabled]));
    const acceleratedCheckoutWasHidden = acceleratedCheckout ? acceleratedCheckout.hidden : false;
    const ownedTargetProperties = ['ギフト包装', '熨斗', '結び方', '包み方', '表書き', 'お名前'];
    const allowedKnots = new Set(['花結び', '結びきり（5本）', '結びきり（10本）', '結びきり 仏事用', '白黒結び切り']);
    const allowedWraps = new Set(['内熨斗', '外熨斗']);
    const standardHeadings = new Set(['表書きなし', '寿', '御結婚御祝', '御祝', '内祝', '御中元', '御歳暮']);
    const storageKey = `c-gift-message-${root.id}`;
    const toNumber = (value) => Number.parseInt(value, 10) || 0;
    const config = {
      cartUrl: root.dataset.cartUrl,
      updateUrl: root.dataset.cartUpdateUrl,
      addUrl: root.dataset.cartAddUrl,
      cartPageUrl: root.dataset.cartPageUrl,
      boxIds: {
        1: toNumber(root.getAttribute('data-box-1-variant-id')),
        2: toNumber(root.getAttribute('data-box-2-variant-id'))
      },
      bagIds: {
        1: toNumber(root.getAttribute('data-bag-1-variant-id')),
        2: toNumber(root.getAttribute('data-bag-2-variant-id'))
      },
      boxReady: {
        1: root.getAttribute('data-box-1-ready') === 'true',
        2: root.getAttribute('data-box-2-ready') === 'true'
      },
      bagReady: {
        1: root.getAttribute('data-bag-1-ready') === 'true',
        2: root.getAttribute('data-bag-2-ready') === 'true'
      },
      hasActiveGroups: root.dataset.hasActiveGroups === 'true',
      liquidCheckoutConflict: root.dataset.checkoutConflict === 'true'
    };
    const state = {
      busy: false,
      validating: config.hasActiveGroups,
      checkoutBlocked: config.liquidCheckoutConflict || config.hasActiveGroups,
      checkoutAuthorized: false
    };
    const dialogControlDisabledStates = new WeakMap();
    const positiveOptionIds = [
      config.boxIds[1],
      config.boxIds[2],
      config.bagIds[1],
      config.bagIds[2]
    ].filter((id) => id > 0);
    const optionConfigurationIsUnique = new Set(positiveOptionIds).size === positiveOptionIds.length;
    const boxIdSet = new Set(Object.values(config.boxIds).filter((id) => id > 0));
    const bagIdSet = new Set(Object.values(config.bagIds).filter((id) => id > 0));
    const optionIdSet = new Set([...boxIdSet, ...bagIdSet]);

    const propertiesOf = (item) => {
      if (!item || !item.properties || typeof item.properties !== 'object') {
        return {};
      }

      return { ...item.properties };
    };

    const itemVariantId = (item) => toNumber(item.variant_id || item.id);

    const itemSellingPlanId = (item) => {
      if (!item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan) {
        return 0;
      }

      return toNumber(item.selling_plan_allocation.selling_plan.id);
    };

    const groupOf = (item) => {
      const value = propertiesOf(item)['ギフト包装'];
      return value == null ? '' : String(value);
    };

    const canonicalProperties = (properties) => Object.keys(properties || {})
      .sort()
      .reduce((result, key) => {
        if (properties[key] != null) {
          result[key] = properties[key];
        }
        return result;
      }, {});

    const itemSignature = (item, properties = propertiesOf(item)) => JSON.stringify({
      id: itemVariantId(item),
      sellingPlan: itemSellingPlanId(item),
      properties: canonicalProperties(properties)
    });

    const itemPayload = (item, quantity, properties = propertiesOf(item)) => {
      const payload = {
        id: itemVariantId(item),
        quantity
      };
      const normalizedProperties = canonicalProperties(properties);
      const sellingPlanId = itemSellingPlanId(item);

      if (Object.keys(normalizedProperties).length > 0) {
        payload.properties = normalizedProperties;
      }
      if (sellingPlanId > 0) {
        payload.selling_plan = sellingPlanId;
      }

      return payload;
    };

    const stripOwnedProperties = (properties) => {
      const result = { ...properties };
      ownedTargetProperties.forEach((key) => delete result[key]);
      return result;
    };

    const showRootMessage = (message, type = 'error') => {
      if (!rootMessage) {
        return;
      }

      rootMessage.textContent = message;
      rootMessage.hidden = !message;
      rootMessage.dataset.messageType = type;
      rootMessage.setAttribute('role', type === 'error' ? 'alert' : 'status');
    };

    const saveReloadMessage = (message, type = 'success') => {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({ message, type }));
      } catch (error) {
        console.error(error);
      }
    };

    const reloadCart = (message = '', type = 'success') => {
      if (message) {
        saveReloadMessage(message, type);
      }
      window.location.assign(config.cartPageUrl);
    };

    const restoreReloadMessage = () => {
      try {
        const saved = window.sessionStorage.getItem(storageKey);
        if (!saved) {
          return;
        }

        window.sessionStorage.removeItem(storageKey);
        const parsed = JSON.parse(saved);
        showRootMessage(parsed.message || '', parsed.type || 'success');
      } catch (error) {
        window.sessionStorage.removeItem(storageKey);
      }
    };

    const setCheckoutBlocked = (blocked) => {
      state.checkoutBlocked = blocked;
      cartForm.dataset.cGiftCheckoutBlocked = String(blocked);

      checkoutButtons.forEach((button) => {
        if (blocked) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.disabled = checkoutDefaults.get(button) || false;
          button.removeAttribute('aria-disabled');
        }
      });

      if (acceleratedCheckout) {
        acceleratedCheckout.hidden = blocked || config.boxReady[1] || config.boxReady[2] || config.hasActiveGroups
          ? true
          : acceleratedCheckoutWasHidden;
      }
    };

    const setBusy = (busy) => {
      state.busy = busy;
      cartForm.classList.toggle('is-c-gift-busy', busy);
      root.setAttribute('aria-busy', String(busy));

      cartForm.querySelectorAll('[data-c-gift-open], [data-c-gift-remove-group]').forEach((control) => {
        control.disabled = busy;
      });

      if (dialog) {
        dialog.querySelectorAll('button, input, select').forEach((control) => {
          if (busy) {
            dialogControlDisabledStates.set(control, control.disabled);
            control.disabled = true;
          } else if (dialogControlDisabledStates.has(control)) {
            control.disabled = dialogControlDisabledStates.get(control);
            dialogControlDisabledStates.delete(control);
          }
        });
      }
    };

    const withCartMutationLock = async (operation) => {
      const lockManager = window.navigator && window.navigator.locks;
      if (!lockManager || typeof lockManager.request !== 'function') {
        return operation();
      }

      return lockManager.request('c-gift-cart-mutation', { mode: 'exclusive' }, operation);
    };

    const requestJson = async (url, options = {}) => {
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        ...options,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          ...(options.headers || {})
        }
      });
      let result = null;

      try {
        result = await response.json();
      } catch (error) {
        result = null;
      }

      if (!response.ok) {
        const message = result && (result.description || result.message)
          ? result.description || result.message
          : `カートの更新に失敗しました（${response.status}）`;
        throw new Error(message);
      }

      return result;
    };

    const getCart = () => requestJson(config.cartUrl);

    const updateLines = async (updates) => {
      if (Object.keys(updates).length === 0) {
        return getCart();
      }

      return requestJson(config.updateUrl, {
        method: 'POST',
        body: JSON.stringify({ updates })
      });
    };

    const addItems = async (items) => {
      const validItems = items.filter((item) => item.quantity > 0);
      if (validItems.length === 0) {
        return null;
      }

      return requestJson(config.addUrl, {
        method: 'POST',
        body: JSON.stringify({ items: validItems })
      });
    };

    const renderedLines = () => Array.from(cartForm.querySelectorAll('[data-c-gift-cart-line]'));

    const renderedLineMap = () => new Map(renderedLines().map((line) => [line.dataset.lineKey, line]));

    const cartMatchesRenderedState = (cart) => {
      const lines = renderedLines();
      if (!cart || !Array.isArray(cart.items) || cart.items.length !== lines.length) {
        return false;
      }

      const itemsByKey = new Map(cart.items.map((item) => [item.key, item]));
      return lines.every((line) => {
        const item = itemsByKey.get(line.dataset.lineKey);
        return item && item.quantity === toNumber(line.dataset.lineQuantity);
      });
    };

    const lockAppliedGiftLines = () => {
      renderedLines().forEach((line) => {
        if (!line.dataset.giftGroup) {
          return;
        }

        const input = line.querySelector('.js-qty__num');
        const adjustButtons = line.querySelectorAll('.js-qty__adjust');
        const remove = line.querySelector('.cart__remove');

        if (input) {
          input.readOnly = true;
          input.setAttribute('aria-readonly', 'true');
        }
        adjustButtons.forEach((button) => {
          button.disabled = true;
          button.hidden = true;
        });
        if (
          remove
          && !remove.querySelector('[data-c-gift-remove-group]')
        ) {
          remove.hidden = true;
        }
      });
    };

    const roleForItem = (item) => {
      const variantId = itemVariantId(item);
      const properties = propertiesOf(item);

      if (boxIdSet.has(variantId)) {
        const capacity = variantId === config.boxIds[1] ? 1 : variantId === config.boxIds[2] ? 2 : 0;
        return { role: 'box', capacity };
      }
      if (bagIdSet.has(variantId)) {
        const size = variantId === config.bagIds[1] ? 1 : variantId === config.bagIds[2] ? 2 : 0;
        return { role: 'bag', size };
      }
      if (Object.prototype.hasOwnProperty.call(properties, '熨斗')) {
        return { role: 'target' };
      }
      if (groupOf(item)) {
        return { role: 'unknown' };
      }
      return { role: 'target' };
    };

    const targetPropertySignature = (item) => {
      const properties = propertiesOf(item);
      return JSON.stringify({
        noshi: properties['熨斗'] || '',
        knot: properties['結び方'] || '',
        wrap: properties['包み方'] || '',
        heading: properties['表書き'] || '',
        name: properties['お名前'] || ''
      });
    };

    const auditGroups = (cart) => {
      const linesByKey = renderedLineMap();
      const groups = new Map();

      cart.items.forEach((item) => {
        const group = groupOf(item);
        if (!group) {
          return;
        }
        if (!groups.has(group)) {
          groups.set(group, []);
        }
        groups.get(group).push(item);
      });

      for (const [group, items] of groups) {
        if (!/^\[[1-9]\d*\]$/.test(group)) {
          return { type: 'group', group };
        }

        const boxes = [];
        const bags = [];
        const targets = [];
        const unknowns = [];

        items.forEach((item) => {
          const role = roleForItem(item);
          if (role.role === 'box') {
            boxes.push({ item, ...role });
          } else if (role.role === 'bag') {
            bags.push({ item, ...role });
          } else if (role.role === 'unknown') {
            unknowns.push(item);
          } else {
            targets.push(item);
          }
        });

        if (unknowns.length > 0) {
          return { type: 'group', group };
        }

        if (boxes.length !== 1 || boxes[0].item.quantity !== 1 || ![1, 2].includes(boxes[0].capacity)) {
          return { type: 'group', group };
        }
        const boxTargetProducts = String(propertiesOf(boxes[0].item)['対象商品'] || '');
        if (!boxTargetProducts || targets.length === 0) {
          return { type: 'group', group };
        }
        if (['熨斗', '結び方', '包み方', '表書き', 'お名前'].some((key) => (
          Object.prototype.hasOwnProperty.call(propertiesOf(boxes[0].item), key)
        ))) {
          return { type: 'group', group };
        }

        const capacity = boxes[0].capacity;
        let targetBottleCount = 0;
        const noshiSignatures = new Set();
        const targetProductTitles = [];

        for (const item of targets) {
          const line = linesByKey.get(item.key);
          const bottleCount = line ? toNumber(line.dataset.giftBottleCount) : 0;
          const properties = propertiesOf(item);
          const noshi = properties['熨斗'];

          if (
            ![1, 2].includes(bottleCount)
            || !['希望する', '希望しない'].includes(noshi)
            || Object.prototype.hasOwnProperty.call(properties, '対象商品')
          ) {
            return { type: 'group', group };
          }
          if (
            noshi === '希望する'
            && (!allowedKnots.has(properties['結び方']) || !allowedWraps.has(properties['包み方']) || !properties['表書き'])
          ) {
            return { type: 'group', group };
          }
          if (noshi === '希望する') {
            const hasNameProperty = Object.prototype.hasOwnProperty.call(properties, 'お名前');
            const hasName = Boolean(properties['お名前'] && String(properties['お名前']).trim());
            if (hasNameProperty && !hasName) {
              return { type: 'group', group };
            }
          }
          if (noshi === '希望しない' && ['結び方', '包み方', '表書き', 'お名前'].some((key) => properties[key])) {
            return { type: 'group', group };
          }

          targetBottleCount += bottleCount * item.quantity;
          noshiSignatures.add(targetPropertySignature(item));
          for (let index = 0; index < item.quantity; index += 1) {
            targetProductTitles.push(item.product_title || item.title);
          }
        }

        const forwardTargetProducts = targetProductTitles.join(',');
        const reverseTargetProducts = [...targetProductTitles].reverse().join(',');
        if (
          targetBottleCount !== capacity
          || noshiSignatures.size !== 1
          || (boxTargetProducts !== forwardTargetProducts && boxTargetProducts !== reverseTargetProducts)
        ) {
          return { type: 'group', group };
        }

        const invalidBags = bags.filter(({ item, size }) => (
          item.quantity !== 1
          || size !== capacity
          || ['熨斗', '結び方', '包み方', '表書き', 'お名前', '対象商品'].some((key) => (
            Object.prototype.hasOwnProperty.call(propertiesOf(item), key)
          ))
        ));
        const bagQuantity = bags.reduce((sum, { item }) => sum + item.quantity, 0);
        if (invalidBags.length > 0 || bagQuantity > 1) {
          return { type: 'bag', group, items: bags.map(({ item }) => item) };
        }
      }

      return { type: 'valid' };
    };

    const aggregateBySignature = (cart, filter = () => true) => {
      const result = new Map();
      cart.items.filter(filter).forEach((item) => {
        const signature = itemSignature(item);
        const current = result.get(signature) || { quantity: 0, item };
        current.quantity += item.quantity;
        result.set(signature, current);
      });
      return result;
    };

    const setAggregateQuantities = async (desired) => {
      let currentCart = await getCart();
      const currentBySignature = new Map();

      currentCart.items.forEach((item) => {
        const signature = itemSignature(item);
        if (!currentBySignature.has(signature)) {
          currentBySignature.set(signature, []);
        }
        currentBySignature.get(signature).push(item);
      });

      const updates = {};
      desired.forEach((target, signature) => {
        const items = currentBySignature.get(signature) || [];
        let excess = items.reduce((sum, item) => sum + item.quantity, 0) - target.quantity;

        for (const item of items) {
          if (excess <= 0) {
            break;
          }
          const reduction = Math.min(excess, item.quantity);
          updates[item.key] = item.quantity - reduction;
          excess -= reduction;
        }
      });

      if (Object.keys(updates).length > 0) {
        await updateLines(updates);
        currentCart = await getCart();
      }

      const currentTotals = aggregateBySignature(currentCart);
      const additions = [];
      desired.forEach((target, signature) => {
        const current = currentTotals.get(signature);
        const deficit = target.quantity - (current ? current.quantity : 0);
        if (deficit > 0) {
          additions.push(itemPayload(target.item, deficit, target.properties));
        }
      });

      if (additions.length > 0) {
        await addItems(additions);
      }

      const verifiedCart = await getCart();
      const verifiedTotals = aggregateBySignature(verifiedCart);
      const restored = Array.from(desired.entries()).every(([signature, target]) => {
        const current = verifiedTotals.get(signature);
        return (current ? current.quantity : 0) === target.quantity;
      });
      if (!restored) {
        throw new Error('カートの復元結果を確認できませんでした。');
      }
    };

    const removeCurrentGroupItems = async (group) => {
      const currentCart = await getCart();
      const updates = {};
      currentCart.items.forEach((item) => {
        if (groupOf(item) === group) {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length > 0) {
        await updateLines(updates);
      }
    };

    const rollbackAddition = async (beforeCart, group, touchedSignatures) => {
      await removeCurrentGroupItems(group);
      const beforeTotals = aggregateBySignature(beforeCart);
      const desired = new Map();

      touchedSignatures.forEach((signature) => {
        const target = beforeTotals.get(signature);
        if (target) {
          desired.set(signature, {
            quantity: target.quantity,
            item: target.item,
            properties: propertiesOf(target.item)
          });
        }
      });

      await setAggregateQuantities(desired);
      const verifiedCart = await getCart();
      if (verifiedCart.items.some((item) => groupOf(item) === group)) {
        throw new Error('追加に失敗したギフト設定を取り除けませんでした。');
      }
    };

    const rollbackRemoval = async (beforeCart, group, targets) => {
      await removeCurrentGroupItems(group);
      const targetBaseSignatures = new Set(targets.map((item) => itemSignature(item, stripOwnedProperties(propertiesOf(item)))));
      const desiredBase = new Map();

      targetBaseSignatures.forEach((signature) => {
        const matchingUngroupedItems = beforeCart.items.filter((item) => (
          groupOf(item) !== group && itemSignature(item) === signature
        ));
        const referenceTarget = targets.find((item) => itemSignature(item, stripOwnedProperties(propertiesOf(item))) === signature);
        desiredBase.set(signature, {
          quantity: matchingUngroupedItems.reduce((sum, item) => sum + item.quantity, 0),
          item: matchingUngroupedItems[0] || referenceTarget,
          properties: matchingUngroupedItems.length > 0
            ? propertiesOf(matchingUngroupedItems[0])
            : stripOwnedProperties(propertiesOf(referenceTarget))
        });
      });

      await setAggregateQuantities(desiredBase);
      const originalGroupItems = beforeCart.items.filter((item) => groupOf(item) === group);
      await addItems(originalGroupItems.map((item) => itemPayload(item, item.quantity)));
      const expectedGroupTotals = aggregateBySignature({ items: originalGroupItems });
      const verifiedCart = await getCart();
      const verifiedGroupTotals = aggregateBySignature(verifiedCart, (item) => groupOf(item) === group);
      const restored = Array.from(expectedGroupTotals.entries()).every(([signature, target]) => {
        const current = verifiedGroupTotals.get(signature);
        return (current ? current.quantity : 0) === target.quantity;
      });
      if (!restored) {
        throw new Error('ギフト設定の復元結果を確認できませんでした。');
      }
    };

    const performCancelGiftGroup = async (group, options = {}) => {
      if (state.busy) {
        return;
      }

      const automatic = options.automatic === true;
      let beforeCart = null;
      let targets = [];
      setBusy(true);
      setCheckoutBlocked(true);

      try {
        beforeCart = await getCart();
        if (!cartMatchesRenderedState(beforeCart)) {
          reloadCart('別の画面でカート内容が変更されたため、最新の状態を表示しました。', 'error');
          return;
        }

        const groupItems = beforeCart.items.filter((item) => groupOf(item) === group);
        if (groupItems.length === 0) {
          reloadCart('ギフト設定はすでに解除されています。');
          return;
        }

        targets = groupItems.filter((item) => {
          const role = roleForItem(item).role;
          return role === 'target' || role === 'unknown';
        });
        const updates = Object.fromEntries(groupItems.map((item) => [item.key, 0]));
        await updateLines(updates);

        const restoredTargets = targets.map((item) => itemPayload(
          item,
          item.quantity,
          stripOwnedProperties(propertiesOf(item))
        ));
        await addItems(restoredTargets);

        const afterCart = await getCart();
        if (afterCart.items.some((item) => groupOf(item) === group)) {
          throw new Error('ギフト設定の解除結果を確認できませんでした。');
        }

        const expectedBase = new Map();
        const ungroupedBefore = aggregateBySignature(beforeCart, (item) => groupOf(item) !== group);
        ungroupedBefore.forEach((value, signature) => expectedBase.set(signature, value.quantity));
        targets.forEach((item) => {
          const baseProperties = stripOwnedProperties(propertiesOf(item));
          const signature = itemSignature(item, baseProperties);
          expectedBase.set(signature, (expectedBase.get(signature) || 0) + item.quantity);
        });
        const afterTotals = aggregateBySignature(afterCart);
        const restoredCorrectly = Array.from(expectedBase.entries()).every(([signature, quantity]) => {
          const current = afterTotals.get(signature);
          return (current ? current.quantity : 0) === quantity;
        });
        if (!restoredCorrectly) {
          throw new Error('対象商品の復元結果を確認できませんでした。');
        }

        reloadCart(
          automatic
            ? 'カート内容の変更を検知したため、該当するギフト設定を自動で解除しました。'
            : 'ギフト設定を解除しました。'
        );
      } catch (error) {
        console.error(error);
        try {
          if (beforeCart) {
            await rollbackRemoval(beforeCart, group, targets);
          }
          reloadCart('ギフト設定を解除できなかったため、変更前の内容へ戻しました。', 'error');
        } catch (rollbackError) {
          console.error(rollbackError);
          reloadCart('カートの復元を完了できませんでした。購入手続きへ進まず、内容をご確認ください。', 'error');
        }
      }
    };

    const cancelGiftGroup = (group, options = {}) => withCartMutationLock(
      () => performCancelGiftGroup(group, options)
    );

    const performRepairInvalidBags = async (group) => {
      if (state.busy) {
        return;
      }

      setBusy(true);
      setCheckoutBlocked(true);
      try {
        const latestCart = await getCart();
        if (!cartMatchesRenderedState(latestCart)) {
          reloadCart('別の画面でカート内容が変更されたため、最新の状態を表示しました。', 'error');
          return;
        }

        const latestAudit = auditGroups(latestCart);
        if (latestAudit.type !== 'bag' || latestAudit.group !== group) {
          reloadCart('手提げ袋の状態が変更されたため、最新の状態を表示しました。', 'error');
          return;
        }

        const repairedKeys = new Set(latestAudit.items.map((item) => item.key));
        const updates = Object.fromEntries(latestAudit.items.map((item) => [item.key, 0]));
        await updateLines(updates);

        const verifiedCart = await getCart();
        if (verifiedCart.items.some((item) => repairedKeys.has(item.key))) {
          throw new Error('手提げ袋の修復結果を確認できませんでした。');
        }
        const verifiedAudit = auditGroups(verifiedCart);
        if (verifiedAudit.type === 'bag' && verifiedAudit.group === group) {
          throw new Error('手提げ袋の不整合が解消されませんでした。');
        }
        reloadCart('手提げ袋の不整合を検知したため、手提げ袋のみカートから削除しました。', 'error');
      } catch (error) {
        console.error(error);
        setBusy(false);
        showRootMessage('手提げ袋の状態を修復できませんでした。購入手続きへ進まず、ページを再読み込みしてください。');
      }
    };

    const repairInvalidBags = (group) => withCartMutationLock(
      () => performRepairInvalidBags(group)
    );

    const nextGroupId = (cart) => {
      let maxGroupNumber = 0;
      cart.items.forEach((item) => {
        const match = groupOf(item).match(/^\[([1-9]\d*)\]$/);
        if (match) {
          maxGroupNumber = Math.max(maxGroupNumber, toNumber(match[1]));
        }
      });
      return `[${maxGroupNumber + 1}]`;
    };

    const dialogElements = dialog ? {
      boxInputs: Array.from(dialog.querySelectorAll('[data-c-gift-box]')),
      targetInputs: Array.from(dialog.querySelectorAll('[data-c-gift-target]')),
      bagInput: dialog.querySelector('[data-c-gift-bag]'),
      bagLabels: Array.from(dialog.querySelectorAll('[data-c-gift-bag-label]')),
      noshi: dialog.querySelector('[data-c-gift-noshi]'),
      noshiDetails: dialog.querySelector('[data-c-gift-noshi-details]'),
      wrap: dialog.querySelector('[data-c-gift-wrap]'),
      heading: dialog.querySelector('[data-c-gift-heading]'),
      other: dialog.querySelector('[data-c-gift-other]'),
      customHeading: dialog.querySelector('[data-c-gift-custom-heading]'),
      name: dialog.querySelector('[data-c-gift-name]'),
      selection: dialog.querySelector('[data-c-gift-selection]'),
      error: dialog.querySelector('[data-c-gift-error]'),
      add: dialog.querySelector('[data-c-gift-add]')
    } : null;

    const selectedBox = () => dialogElements.boxInputs.find((input) => input.checked && !input.disabled);

    const selectedCapacity = () => {
      const box = selectedBox();
      return box ? toNumber(box.dataset.capacity) : 0;
    };

    const selectedBottleCount = () => dialogElements.targetInputs
      .filter((input) => input.checked)
      .reduce((sum, input) => sum + toNumber(input.dataset.bottleCount), 0);

    const showDialogError = (message) => {
      if (!dialogElements) {
        return;
      }
      dialogElements.error.textContent = message;
      dialogElements.error.hidden = !message;
    };

    const updateBagChoice = () => {
      const capacity = selectedCapacity();
      dialogElements.bagLabels.forEach((label) => {
        label.hidden = toNumber(label.dataset.cGiftBagLabel) !== capacity;
      });
      const ready = config.bagReady[capacity] && config.bagIds[capacity] > 0;
      dialogElements.bagInput.disabled = !ready || state.busy;
      if (!ready) {
        dialogElements.bagInput.checked = false;
      }
    };

    const updateSelectionMessage = () => {
      const capacity = selectedCapacity();
      dialogElements.selection.textContent = `選択中：${selectedBottleCount()}本 / ${capacity}本`;
    };

    const updateNoshiFields = () => {
      const wantsNoshi = dialogElements.noshi.value === '希望する';
      const isOther = wantsNoshi && dialogElements.heading.value === 'その他';
      dialogElements.noshiDetails.hidden = !wantsNoshi;
      dialogElements.other.hidden = !isOther;
      dialogElements.customHeading.required = isOther;
      dialogElements.name.required = false;
    };

    const resetDialog = () => {
      const firstAvailableBox = dialogElements.boxInputs.find((input) => !input.disabled);
      dialogElements.boxInputs.forEach((input) => {
        input.checked = input === firstAvailableBox;
      });
      dialogElements.targetInputs.forEach((input) => {
        input.checked = false;
      });
      dialogElements.bagInput.checked = false;
      dialogElements.noshi.value = '希望しない';
      dialogElements.wrap.value = '内熨斗';
      dialogElements.heading.value = '表書きなし';
      dialogElements.customHeading.value = '';
      dialogElements.name.value = '';
      const firstKnot = dialog.querySelector('[name^="c-gift-knot-"]');
      if (firstKnot) {
        firstKnot.checked = true;
      }
      showDialogError('');
      updateBagChoice();
      updateSelectionMessage();
      updateNoshiFields();
    };

    const closeDialog = () => {
      if (!dialog || state.busy) {
        return;
      }
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const openDialog = () => {
      if (!dialog || state.busy) {
        return;
      }
      if (state.validating) {
        showRootMessage('ギフト設定を確認しています。少し待ってからもう一度お試しください。', 'status');
        return;
      }
      if (!optionConfigurationIsUnique) {
        showRootMessage('ギフトボックスと手提げ袋には、それぞれ異なる商品を設定してください。');
        return;
      }

      resetDialog();
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const performAddGift = async () => {
      if (!dialogElements || state.busy) {
        return;
      }

      showDialogError('');
      const box = selectedBox();
      const capacity = selectedCapacity();
      const targetInputs = dialogElements.targetInputs.filter((input) => input.checked);
      const bottleCount = selectedBottleCount();

      if (!box || !config.boxReady[capacity]) {
        showDialogError('ギフトボックスを選択してください。');
        return;
      }
      if (targetInputs.length === 0 || bottleCount !== capacity) {
        showDialogError(`箱に入れる商品の合計を${capacity}本にしてください。`);
        return;
      }
      if (dialogElements.bagInput.checked && (!config.bagReady[capacity] || config.bagIds[capacity] <= 0)) {
        showDialogError('選択した箱に対応する手提げ袋は現在追加できません。');
        return;
      }

      const wantsNoshi = dialogElements.noshi.value === '希望する';
      const headingIsOther = wantsNoshi && dialogElements.heading.value === 'その他';
      const customHeading = dialogElements.customHeading.value.trim();
      const name = dialogElements.name.value.trim();
      if (headingIsOther && !customHeading) {
        showDialogError('「その他」を選択した場合は、ご希望の表書きを入力してください。');
        return;
      }
      if (headingIsOther && standardHeadings.has(customHeading)) {
        showDialogError('一覧にある表書きは「その他」ではなく、一覧から選択してください。');
        return;
      }

      const selectedByKey = new Map();
      targetInputs.forEach((input) => {
        const current = selectedByKey.get(input.dataset.lineKey) || {
          quantity: 0,
          bottleCount: toNumber(input.dataset.bottleCount)
        };
        current.quantity += 1;
        selectedByKey.set(input.dataset.lineKey, current);
      });

      const previousCheckoutBlocked = state.checkoutBlocked;
      let beforeCart = null;
      let group = '';
      const touchedSignatures = new Set();
      setBusy(true);
      setCheckoutBlocked(true);

      try {
        beforeCart = await getCart();
        if (!cartMatchesRenderedState(beforeCart)) {
          reloadCart('別の画面でカート内容が変更されたため、最新の状態を表示しました。', 'error');
          return;
        }

        const itemsByKey = new Map(beforeCart.items.map((item) => [item.key, item]));
        const selectedItems = [];
        selectedByKey.forEach((selection, key) => {
          const item = itemsByKey.get(key);
          const itemProperties = propertiesOf(item);
          if (
            !item
            || groupOf(item)
            || optionIdSet.has(itemVariantId(item))
            || itemProperties['対象商品']
            || ownedTargetProperties.some((property) => (
              Object.prototype.hasOwnProperty.call(itemProperties, property)
            ))
            || itemSellingPlanId(item) > 0
            || item.quantity < selection.quantity
          ) {
            throw new Error('選択した商品の状態が変わりました。ページを再読み込みして設定し直してください。');
          }
          selectedItems.push({ item, selection });
          touchedSignatures.add(itemSignature(item));
        });

        group = nextGroupId(beforeCart);
        const targetProperties = {
          'ギフト包装': group,
          '熨斗': wantsNoshi ? '希望する' : '希望しない'
        };
        if (wantsNoshi) {
          const knot = dialog.querySelector('[name^="c-gift-knot-"]:checked');
          if (!knot) {
            throw new Error('結び方を選択してください。');
          }
          targetProperties['結び方'] = knot.value;
          targetProperties['包み方'] = dialogElements.wrap.value;
          targetProperties['表書き'] = headingIsOther ? customHeading : dialogElements.heading.value;
          if (name) {
            targetProperties['お名前'] = name;
          }
        }

        const updates = {};
        const giftTargets = [];
        const targetTitles = [];
        selectedItems.forEach(({ item, selection }) => {
          updates[item.key] = item.quantity - selection.quantity;
          const properties = {
            ...stripOwnedProperties(propertiesOf(item)),
            ...targetProperties
          };
          giftTargets.push(itemPayload(item, selection.quantity, properties));
          for (let index = 0; index < selection.quantity; index += 1) {
            targetTitles.push(item.product_title || item.title);
          }
        });

        await updateLines(updates);
        const giftItems = [
          ...giftTargets,
          {
            id: toNumber(box.value),
            quantity: 1,
            properties: {
              'ギフト包装': group,
              '対象商品': targetTitles.join(',')
            }
          }
        ];
        if (dialogElements.bagInput.checked) {
          giftItems.push({
            id: config.bagIds[capacity],
            quantity: 1,
            properties: {
              'ギフト包装': group
            }
          });
        }
        await addItems(giftItems);

        const afterCart = await getCart();
        const groupItems = afterCart.items.filter((item) => groupOf(item) === group);
        const boxes = groupItems.filter((item) => itemVariantId(item) === toNumber(box.value));
        const allBoxes = groupItems.filter((item) => boxIdSet.has(itemVariantId(item)));
        const bags = groupItems.filter((item) => bagIdSet.has(itemVariantId(item)));
        const targets = groupItems.filter((item) => !optionIdSet.has(itemVariantId(item)));
        const bottleCountByVariant = new Map(selectedItems.map(({ item, selection }) => [
          itemVariantId(item),
          selection.bottleCount
        ]));
        const verifiedBottleCount = targets.reduce((sum, item) => (
          sum + (bottleCountByVariant.get(itemVariantId(item)) || 0) * item.quantity
        ), 0);
        const expectedBagQuantity = dialogElements.bagInput.checked ? 1 : 0;
        const verifiedProperties = targets.every((item) => {
          const properties = propertiesOf(item);
          return Object.entries(targetProperties).every(([key, value]) => properties[key] === value);
        });

        if (
          boxes.length !== 1
          || allBoxes.length !== 1
          || boxes[0].quantity !== 1
          || propertiesOf(boxes[0])['対象商品'] !== targetTitles.join(',')
          || verifiedBottleCount !== capacity
          || bags.reduce((sum, item) => sum + item.quantity, 0) !== expectedBagQuantity
          || (expectedBagQuantity === 1 && itemVariantId(bags[0]) !== config.bagIds[capacity])
          || !verifiedProperties
        ) {
          throw new Error('ギフト設定の追加結果を確認できませんでした。');
        }

        reloadCart('ギフト設定を追加しました。');
      } catch (error) {
        console.error(error);
        if (!beforeCart || !group) {
          setBusy(false);
          setCheckoutBlocked(previousCheckoutBlocked);
          showDialogError(error.message || 'ギフト設定を追加できませんでした。');
          return;
        }

        try {
          await rollbackAddition(beforeCart, group, touchedSignatures);
          reloadCart('ギフト設定を追加できなかったため、変更前の内容へ戻しました。', 'error');
        } catch (rollbackError) {
          console.error(rollbackError);
          reloadCart('カートの復元を完了できませんでした。購入手続きへ進まず、内容をご確認ください。', 'error');
        }
      }
    };

    const addGift = () => withCartMutationLock(performAddGift);

    const bindDialog = () => {
      if (!dialog || !dialogElements) {
        return;
      }

      dialogElements.boxInputs.forEach((input) => {
        input.addEventListener('change', () => {
          dialogElements.targetInputs.forEach((target) => {
            target.checked = false;
          });
          dialogElements.bagInput.checked = false;
          showDialogError('');
          updateBagChoice();
          updateSelectionMessage();
        });
      });

      dialogElements.targetInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (selectedBottleCount() > selectedCapacity()) {
            input.checked = false;
            showDialogError(`選択できる商品は合計${selectedCapacity()}本までです。`);
          } else {
            showDialogError('');
          }
          updateSelectionMessage();
        });
      });

      dialogElements.noshi.addEventListener('change', updateNoshiFields);
      dialogElements.heading.addEventListener('change', updateNoshiFields);
      dialogElements.add.addEventListener('click', addGift);
      dialog.querySelectorAll('[data-c-gift-close]').forEach((button) => {
        button.addEventListener('click', closeDialog);
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeDialog();
        }
      });
    };

    cartForm.querySelectorAll('[data-c-gift-open]').forEach((button) => {
      button.addEventListener('click', openDialog);
    });
    cartForm.addEventListener('click', (event) => {
      const removeGroupControl = event.target.closest('[data-c-gift-remove-group]');
      if (removeGroupControl) {
        event.preventDefault();
        event.stopImmediatePropagation();
        cancelGiftGroup(removeGroupControl.dataset.cGiftRemoveGroup);
        return;
      }

      const line = event.target.closest('[data-c-gift-cart-line]');
      if (!line || !line.dataset.giftGroup) {
        return;
      }
      if (event.target.closest('.js-qty__adjust') || event.target.closest('.cart__remove a')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showRootMessage('商品の変更・削除前に「ギフトをやめる」を実行してください。');
      }
    }, true);

    cartForm.addEventListener('input', (event) => {
      const line = event.target.closest('[data-c-gift-cart-line]');
      if (line && line.dataset.giftGroup && event.target.matches('.js-qty__num')) {
        event.preventDefault();
        event.target.value = line.dataset.lineQuantity;
      }
    }, true);

    const validateGiftBeforeCheckout = async (submitter) => {
      if (state.busy || state.validating) {
        return;
      }

      state.validating = true;
      setCheckoutBlocked(true);
      try {
        const cart = await getCart();
        if (!cartMatchesRenderedState(cart)) {
          reloadCart('別の画面でカート内容が変更されたため、最新の状態を表示しました。', 'error');
          return;
        }

        const audit = auditGroups(cart);
        if (audit.type === 'group') {
          state.validating = false;
          await cancelGiftGroup(audit.group, { automatic: true });
          return;
        }
        if (audit.type === 'bag') {
          state.validating = false;
          await repairInvalidBags(audit.group);
          return;
        }

        state.validating = false;
        setCheckoutBlocked(false);
        state.checkoutAuthorized = true;
        const checkoutButton = checkoutButtons.includes(submitter)
          ? submitter
          : checkoutButtons.find((button) => !button.disabled);

        if (typeof cartForm.requestSubmit === 'function') {
          cartForm.requestSubmit(checkoutButton);
        } else if (checkoutButton) {
          checkoutButton.click();
        } else {
          throw new Error('購入手続きボタンを確認できませんでした。');
        }
      } catch (error) {
        console.error(error);
        state.checkoutAuthorized = false;
        state.validating = false;
        setCheckoutBlocked(true);
        showRootMessage('ギフト設定を再確認できませんでした。購入手続きへ進まず、ページを再読み込みしてください。');
      }
    };

    cartForm.addEventListener('submit', (event) => {
      if (state.checkoutAuthorized) {
        state.checkoutAuthorized = false;
        return;
      }
      if (state.busy || state.validating || state.checkoutBlocked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showRootMessage('ギフト設定の確認が完了するまで購入手続きへ進めません。');
        return;
      }
      if (!config.hasActiveGroups) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      validateGiftBeforeCheckout(event.submitter);
    }, true);

    document.addEventListener('cart:updated', () => {
      if (!state.busy) {
        reloadCart();
      }
    });

    const initialize = async () => {
      restoreReloadMessage();
      lockAppliedGiftLines();
      bindDialog();
      setCheckoutBlocked(state.checkoutBlocked);

      if (!optionConfigurationIsUnique) {
        state.validating = false;
        if (config.hasActiveGroups) {
          setCheckoutBlocked(true);
          showRootMessage('ギフト商品設定が重複しています。購入手続きへ進まず、ショップへお問い合わせください。');
        }
        return;
      }

      if (!config.hasActiveGroups) {
        state.validating = false;
        setCheckoutBlocked(config.liquidCheckoutConflict);
        return;
      }

      try {
        const cart = await getCart();
        if (!cartMatchesRenderedState(cart)) {
          reloadCart('別の画面でカート内容が変更されたため、最新の状態を表示しました。', 'error');
          return;
        }

        const audit = auditGroups(cart);
        if (audit.type === 'group') {
          state.validating = false;
          await cancelGiftGroup(audit.group, { automatic: true });
          return;
        }
        if (audit.type === 'bag') {
          state.validating = false;
          await repairInvalidBags(audit.group);
          return;
        }

        state.validating = false;
        setCheckoutBlocked(config.liquidCheckoutConflict);
      } catch (error) {
        console.error(error);
        state.validating = false;
        setCheckoutBlocked(true);
        showRootMessage('ギフト設定を確認できませんでした。購入手続きへ進まず、ページを再読み込みしてください。');
      }
    };

    initialize();
  })();
